import Vue from 'vue';
import orderTransformer from '../../transformers/order';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: orderTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default (orderIds, order) => (
  new Promise((resolve, reject) => {
    const url = `/orders/confirm-order-shipping?order_ids=${orderIds.join(',')}`;

    Vue.$http
      .post(url, order)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/bulkConfirmAndShipping.js